
function TimeControls({ timeSpeed, setTimeSpeed, isPaused, setIsPaused }) {
  const speeds = [0.1, 0.5, 1, 2, 5, 10];
  
  return (
    <div style={{
      position: 'absolute',
      bottom: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      background: 'rgba(0,0,0,0.8)',
      padding: '15px',
      borderRadius: '12px',
      display: 'flex',
      gap: '10px',
      alignItems: 'center',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(255,255,255,0.1)'
    }}>
      <button
        onClick={() => setIsPaused(!isPaused)}
        style={{
          background: isPaused ? '#4CAF50' : '#FF9800',
          border: 'none',
          color: 'white',
          padding: '8px 12px',
          borderRadius: '6px',
          cursor: 'pointer',
          fontSize: '14px'
        }}
      >
        {isPaused ? '▶️ Play' : '⏸️ Pause'}
      </button>
      
      <div style={{ color: 'white', fontSize: '12px' }}>Speed:</div>
      
      {speeds.map(speed => (
        <button
          key={speed}
          onClick={() => setTimeSpeed(speed)}
          style={{
            background: timeSpeed === speed ? '#2196F3' : 'rgba(255,255,255,0.1)',
            border: '1px solid rgba(255,255,255,0.2)',
            color: 'white',
            padding: '6px 10px',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '12px'
          }}
        >
          {speed}x
        </button>
      ))}
    </div>
  );
}

export default TimeControls